import React from 'react';
import { COLORS } from '../../styles/tokens';

const ICONS = {
  shield: <path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z" />,
  card:   <><rect x="3" y="5" width="18" height="14" rx="2.5" /><path d="M3 10h18" /></>,
  pin:    <><path d="M12 21s7-6.2 7-11.5a7 7 0 10-14 0C5 14.8 12 21 12 21z" /><circle cx="12" cy="9.5" r="2.5" /></>,
  chat:   <path d="M4 5h16v11H9l-5 4z" />,
  bell:   <path d="M6 17V11a6 6 0 1112 0v6l1.5 2h-15zM10 21h4" />,
  list:   <path d="M8 6h12M8 12h12M8 18h12M4 6h.01M4 12h.01M4 18h.01" />,
  sun:    <><circle cx="12" cy="12" r="4" /><path d="M12 3v2M12 19v2M3 12h2M19 12h2M5.6 5.6L7 7M17 17l1.4 1.4M5.6 18.4L7 17M17 7l1.4-1.4" /></>,
  lock:   <><rect x="5" y="11" width="14" height="9" rx="2" /><path d="M8 11V8a4 4 0 018 0v3" /></>,
  plus:   <path d="M12 5v14M5 12h14" />,
  swap:   <path d="M4 8h14l-3-3M20 16H6l3 3" />,
  out:    <><path d="M9 4H5a2 2 0 00-2 2v12a2 2 0 002 2h4" /><path d="M16 8l4 4-4 4M20 12H9" /></>,
  layers: <><path d="M12 3l9 5-9 5-9-5z" /><path d="M3 13l9 5 9-5" /></>,
  users:  <><circle cx="9" cy="8" r="3.5" /><path d="M2.5 20c0-3.5 3-6 6.5-6s6.5 2.5 6.5 6" /><circle cx="17.5" cy="9" r="2.5" /><path d="M17 14.5c2.5 0 4.5 1.8 4.5 4.5" /></>,
};

export function RowIcon({ name }) {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {ICONS[name]}
    </svg>
  );
}

const VALUE_COLORS = { warning: COLORS.warningText, success: COLORS.successText };

// Menyrad i profilen. onClick gir knapp med «›»; danger gir rød rad (Logg ut) uten «›».
// expanded/controls brukes når raden åpner et panel rett under (se ExpandRow).
export function MenuRow({ icon, label, value, valueTone, onClick, danger, expanded, controls, id }) {
  const Tag = onClick ? 'button' : 'div';
  const a11y = onClick && expanded !== undefined ? { 'aria-expanded': expanded, 'aria-controls': controls } : {};
  return (
    <Tag
      id={id} data-danger={danger ? 'true' : undefined} onClick={onClick} {...(onClick ? { type: 'button' } : {})} {...a11y}
      style={{ ...styles.row, color: danger ? COLORS.danger : COLORS.textDark, cursor: onClick ? 'pointer' : 'default' }}
    >
      <RowIcon name={icon} />
      <span style={styles.label}>{label}</span>
      {value && <span style={{ ...styles.value, ...(VALUE_COLORS[valueTone] ? { color: VALUE_COLORS[valueTone], fontWeight: 600 } : {}) }}>{value}</span>}
      {onClick && !danger && (
        <span aria-hidden="true" style={{ ...styles.chev, ...(expanded ? { transform: 'rotate(90deg)' } : {}) }}>›</span>
      )}
    </Tag>
  );
}

// Rad som folder ut innholdet rett under seg (som «Varsler»). anchorId gir hash-lenker (f.eks. #faktura).
export function ExpandRow({ name, anchorId, icon, label, value, valueTone, open, onToggle, children }) {
  const panelId = `${name}-panel`;
  const rowId = `${name}-row`;
  return (
    <div id={anchorId} style={{ scrollMarginTop: 70 }}>
      <MenuRow id={rowId} icon={icon} label={label} value={value} valueTone={valueTone} expanded={open} controls={panelId} onClick={onToggle} />
      {open && (
        <div id={panelId} role="region" aria-labelledby={rowId} style={styles.panel}>
          {children}
        </div>
      )}
    </div>
  );
}

const styles = {
  row:   { display: 'flex', alignItems: 'center', gap: 12, width: '100%', padding: '15px 0', background: 'none', border: 'none', borderBottom: `1px solid ${COLORS.border}`, textAlign: 'left', fontFamily: 'inherit' },
  label: { fontWeight: 600, fontSize: 15 },
  value: { marginLeft: 'auto', fontSize: 13, color: COLORS.textLight, textAlign: 'right' },
  chev:  { fontSize: 22, color: COLORS.textLight, lineHeight: 1, marginLeft: 4, transition: 'transform 0.15s' },
  panel: { padding: '12px 0 16px', borderBottom: `1px solid ${COLORS.border}` },
};
